import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { ActivatedRoute, Params, Router }   from '@angular/router';

import { AuthService } from '../auth/auth.service';
import { environment } from 'environments/environment';

import { routerTransition } from '../app-routing-transition';

@Component({
  selector: 'login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
  animations: [
    trigger(
      'mainAnimation', [
        transition(':enter', [
          style({opacity: 0}),
          animate('400ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('400ms', style({opacity: 0}))
        ])
      ]
    ),
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({transform: 'scale(0)', opacity: 0}),
          animate('400ms', style({transform: 'scale(1)', opacity: 1}))
        ]),
        transition(':leave', [
          style({transform: 'scale(1)', opacity: 1}),
          animate('400ms', style({transform: 'scale(0)', opacity: 0}))
        ])
      ]
    ),
    trigger(
      'pictureAnimation', [
        transition(':enter', [
          style({
            transform: 'translateX(50%) translateY(50%)',
            opacity: 0,
            top: '50%',
            right: '50%',
            width: '75px',
            height: '75px',
          }),
          animate('400ms', style({
            transform: 'translateX(50%) translateY(50%)',
            opacity: 1,
            top: '50%',
            right: '50%',
            width: '75px',
            height: '75px',
          })),
          animate('400ms', style({
            transform: 'translateX(0) translateY(0)',
            opacity: 1,
            top: '14px',
            right: '40px',
            width: '35px',
            height: '35px',
          }))
        ]),
        transition(':leave', [
          style({
            transform: 'scale(1) translateX(50%) translateY(50%)',
            opacity: 1,
          }),
          animate('400ms', style({transform: 'scale(0)', opacity: 0}))
        ])
      ]
    )
  ],
  host: {'[@mainAnimation]': ''},
})
export class LoginComponent implements OnInit {

  public loading: boolean = true;
  public identifier: string = '';
  public password: string = '';
  public errorMessage: string = null;
  public googleUrl: string;
  public user: any = null;

  private redirect: string = '/';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  public ngOnInit() {
    this.route
      .queryParams
      .subscribe((params) => {
        if (params && params['redirect']) {
          this.redirect = params['redirect'];
        }

        this.googleUrl = environment.API_URL + '/ws/mw/login/google?redirect='
          + encodeURIComponent(window.location.origin + this.redirect);

        this.authService.getUser()
          .subscribe((user) => {
            this.user = user;
            this.loading = false;
          });
      });
  }

  public goToRedirection() {
    this.router.navigateByUrl(this.redirect);
  }

  public onSubmit() {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.authService.login(this.identifier, this.password)
      .subscribe((res) => {
        this.loading = false;
      }, (err) => {
        if (err.status === 401) {
          this.errorMessage = 'Identifiant ou mot de passe incorrect';
        }
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts